import { useRuntimeConfig } from '#app'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import type { AlgoliaDomain } from '../types'

export type { AlgoliaDomain }

type AlgoliaSearchOptions = {
  hosts: { url: string; protocol: string }[]
  headers: Record<string, string>
}

export function useAlgoliaSearchOptions(
  domain: AlgoliaDomain,
): AlgoliaSearchOptions {
  const { market } = useMarketplace()
  const { ALGOLIA_HOST } = useRuntimeConfig().public

  const host = computed(() =>
    ((ALGOLIA_HOST as string) || '')?.replaceAll(
      '{market.domain}',
      market.domain,
    ),
  )

  const serverOnlyHeaders: Record<string, string> = import.meta.server
    ? {
        'user-agent': 'bm-search-javascript-client',
      }
    : {}

  return {
    hosts: [{ url: host.value, protocol: 'https' }],
    headers: {
      'BM-Search-Domain': domain,
      ...serverOnlyHeaders,
    },
  }
}
